module.exports = __webpack_public_path__ + "img/404browser.bb6a7147.svg";